import { NodeDTOTypes } from '@store/services/nodes/types';

export type RelationCompatibilityRule = {
  type: NodeDTOTypes;
  canHaveMultipleParents: boolean;
};

export const nodeChildrenCompatibility: Record<
  NodeDTOTypes,
  RelationCompatibilityRule[]
> = {
  [NodeDTOTypes.StrategicPriority]: [
    { type: NodeDTOTypes.StrategicEnabler, canHaveMultipleParents: true },
  ],
  [NodeDTOTypes.StrategicEnabler]: [
    { type: NodeDTOTypes.BusinessAttribute, canHaveMultipleParents: true },
  ],
  [NodeDTOTypes.BusinessAttribute]: [
    { type: NodeDTOTypes.SecurityAttribute, canHaveMultipleParents: true },
  ],
  [NodeDTOTypes.SecurityAttribute]: [
    { type: NodeDTOTypes.Service, canHaveMultipleParents: true },
  ],
  [NodeDTOTypes.Service]: [
    { type: NodeDTOTypes.Capabilities, canHaveMultipleParents: false },
    { type: NodeDTOTypes.Initiatives, canHaveMultipleParents: true },
  ],
  [NodeDTOTypes.Capabilities]: [
    { type: NodeDTOTypes.Functions, canHaveMultipleParents: false },
    { type: NodeDTOTypes.Initiatives, canHaveMultipleParents: true },
  ],
  [NodeDTOTypes.Functions]: [
    { type: NodeDTOTypes.Technologies, canHaveMultipleParents: true },
    { type: NodeDTOTypes.Initiatives, canHaveMultipleParents: true },
  ],
  [NodeDTOTypes.Technologies]: [],
  [NodeDTOTypes.Initiatives]: [],
  [NodeDTOTypes.Asset]: [
    { type: NodeDTOTypes.BusinessAttribute, canHaveMultipleParents: true },
    { type: NodeDTOTypes.Characteristic, canHaveMultipleParents: false },
  ],
  [NodeDTOTypes.Characteristic]: [
    { type: NodeDTOTypes.EvaluatedRisk, canHaveMultipleParents: true },
  ],
  [NodeDTOTypes.EvaluatedRisk]: [
    { type: NodeDTOTypes.Capabilities, canHaveMultipleParents: true },
  ],
};
